import { Injectable } from '@angular/core';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { AuthService } from '@public/src/application/services/auth/mod';
import { IdentityApiModel } from './Models/IdentityApiModel';
import { sharedResolution } from '@public/src/shared_resolution';

@Injectable()
export class IdentityServiceV2 {
	readonly baseUri = '/api/Client/v2/Identity/';

	constructor(private http: VisibaApiHttp) {}

	public get() {
		const authService = sharedResolution.resolve(AuthService);

		return from(
			authService.fetchActiveIdentity().then((user) => {
				return user;
			}),
		);
	}

	public isAlive() {
		let headers = new HttpHeaders();
		headers = headers.append('X-TouchSessions', 'false');

		return this.http.getTyped<boolean>(`${this.baseUri}IsAlive`, false, { headers });
	}

	public isAliveOutsider() {
		let headers = new HttpHeaders();

		headers = headers.append('X-TouchSessions', 'false');

		return this.http.getTyped<boolean>(`${this.baseUri}IsAliveOutsider`, false, { headers });
	}

	public signOut() {
		localStorage.removeItem('identitySession');

		return this.http.postTyped<{ RedirectUrl: null | string }>(`${this.baseUri}SignOut`, null);
	}

	public update(
		givenName: string,
		surname: string,
		email: string,
		phoneNumber: string,
		countryCode: string,
		phoneVerificationAttemptId: string | null = null,
	): Observable<ApiResponse<IdentityApiModel>> {
		const postData = {
			FirstName: givenName,
			LastName: surname,
			Email: email,
			Phone: phoneNumber,
			Nationality: countryCode,
			PhoneVerificationAttemptId: phoneVerificationAttemptId,
		};

		return this.http.putTyped<IdentityApiModel>(`${this.baseUri}`, postData);
	}
}
